
<template>
    <div>
        <el-dialog title="师傅" :visible.sync="workerVisible">
             <avue-crud-table :data="workerData" :option="tableoptionwork" @search-change="searchChangegr" @selection-change="workSelectionChange" ref="reFreshFarther"></avue-crud-table>
             <div slot="footer" class="dialog-footer">
                <!-- <el-button @click="workerVisible = false">关闭</el-button> -->
                <el-button @click="creates">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {getDictList} from '@/api/admin/dict'
    import {getWorkerList} from '@/api/admin/addProject'
    import { objKeySort } from '@/util/ajaxsign'
    import {dealElement} from '@/util/util'
    import {addsObj} from '@/api/admin/groups'
    export default {
        data() {
            return {
                workerVisible : false,
                workerData : [],
                tableoptionwork : {
                    addBtn : false,
                    selection : true,
                    refreshBtn : false,
                    columnBtn : true,
                    editBtn : false,
                    delBtn : false,
                    menu : false,
                    columnBtn : false,
                    refreshBtn : false,
                    columnBtn : false,
                    header : true,
                    headerMenu : false,
                    page:true,
                    border : true,
                    searchLabelWidth:'80',
                    search:{
                        prop:'condition',
                        label:'师傅信息',
                        searchPlaceholder:'请输入关键字'
                    },
                  align:'center',
                  menuAlign:'center',
                  height : window.innerHeight - 230,
                  index:false,
                  column:[
                    {
                    label:'手机号码',
                    prop:'phone',
                    overHidden : true,
                  },
                  {
                    label:'姓名',
                    prop:'name',
                    overHidden : true,
                  },{
                    label:'团队认证',
                    prop:'isForeman',
                    search : true,
                    type:'select',
                    dicData : [{label:'已认证',value:1},{label:'未认证',value:0}],
                    overHidden : true,
                    formatter: function(row){
                        return  row.isForeman ==1? '已认证' : '未认证'
                    }
                  },{
                    label:'工种',
                    prop:'workTypeIds',
                    type:'select',
                    dicData : {},
                    props : {
                        label: 'name',
                        value: 'id'
                    },
                    search : true,
                    overHidden : true
                    },{
                      label:'实名状态',
                      prop:'workerState',
                      formatter: function(row){
                        if(row.workerState == 1){
                          return "审核中";
                        }else if(row.workerState == 2){
                          return "已认证";
                        }else{
                          return "未认证";
                        }
                      }
                    }
                  ]
                },
                dic:{
                  workTypes:[],
                  skillTips:[],
                  groups:[]
                },
                groupId : '',
                groupids :[],
                tags:[]
            }

        },
        created() {
            this.initDic()
        },

        methods: {
            //设置展示
            setsataus(groupId,groups){
                console.log(groupId)
                this.workerVisible = true;
                this.groupId = groupId;
                this.workerBtn();
            },

            initDic(){
              getDictList(objKeySort({code:"worktype"})).then(response => {
                  this.dic.workTypes = response.data.data.worktype;
                  this.tableoptionwork.column[3].dicData =response.data.data.worktype
              })
               getDictList(objKeySort({code:"worker_skill"})).then(response => {
                  this.dic.skillTips = response.data.data.worker_skill;
              })
            },

            workerBtn(){
              let that=this
              that.tags=[]
              getWorkerList(dealElement(objKeySort({}))).then(response =>{
                  that.workerData =response.data.data;
                  let _workIds = sessionStorage.getItem("workIds")?JSON.parse(sessionStorage.getItem("workIds")):[];
                  response.data.data.forEach(comworker => {
                    comworker.workTypeIds = that.formatterWorkType(comworker.workTypeIds);
                    if (_workIds.workIds.length>0) {
                      _workIds.workIds.forEach(tag => {
                        if (tag == comworker.id) {
                          that.tags.push(comworker);
                        }
                      });
                    }
                  });
                  that.$nextTick(() => {
                    that.tags.forEach(tag => {
                      that.$refs.reFreshFarther.toggleRowSelection(tag, true);
                    });
                  })
              })
              that.workerVisible=true
            },

             //刷新列表操作
            formatterWorkType(workTypeIds){
                var  workTypeNames = '';
                if(workTypeIds&&workTypeIds.length>0){
                    workTypeIds.split(",").forEach(workerTypeId =>{
                        if(this.dic.workTypes){
                            this.dic.workTypes.forEach(workerType => {
                                if(workerType.id==workerTypeId){
                                    workTypeNames = workTypeNames + workerType.name +',';
                                }
                            })
                        }else{
                            return workTypeIds;
                        }

                    })
                }
                if(workTypeNames.length>0){
                    workTypeNames = workTypeNames.substring(0,workTypeNames.length-1);
                }
                return  workTypeNames;
            },

            //搜索师傅信息
            searchChangegr(params){
                this.searchgr = {
                    condition : params.condition,
                    groupId : params.groupNames,
                    isForeman : params.isForeman,
                    workTypeId : params.workTypeIds
                }
                getWorkerList(objKeySort(dealElement(this.searchgr))).then(response =>{
                    this.workerData =response.data.data;
                    this.workerData.forEach(data =>{
                        data.workTypeIds = this.formatterWorkType(data.workTypeIds);
                    })
                })
                console.log(this.searchgr)
            },

             // 我的师傅多选
            workSelectionChange(val){
                this.groupids =val
            },

             // 查看师傅 确定
            creates() {
                let that=this
                console.log(that.groupids)
                var ids = [];
                for(var i=0;i<that.groupids.length;i++){
                    ids.push(that.groupids[i].urId)
                }
                ids = ids.join(',');
                console.log(ids)
                addsObj(objKeySort({groupId:that.groupId,urIds:ids})).then(() => {
                    that.workerVisible = false
                    that.$message({
                        title: '成功',
                        message: '添加成功',
                        type: 'success',
                        duration: 2000
                    })
                    that.$emit('func',"refresh")
                })
            },
        }
    }
</script>
